import React, {useContext, useState} from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'src/utils/useNavigate';
import Button from 'src/components/Button';
import routes from 'src/constants/routes';
import { postLeaveOrganizationAPI } from 'src/serverApi/organizationUsers';
import useWithAuthorities from 'src/utils/useWithAuthorities';
import permissions from 'src/constants/permissions';
import Modal from 'src/components/Modal';
import Text from 'src/components/Text';
import { OrganizationsContext, ReloadOrganizationsContext } from '../OrganizationContextProvider';
import styles from './styles.module.scss';

type Props = {
  className?: string;
}

const LeaveOrganizationLink: React.FC<Props> = ({ className }) => {
  const navigate = useNavigate();
  const { currentOrganization } = useContext(OrganizationsContext);
  const reloadOrganizations = useContext(ReloadOrganizationsContext);
  const withDataManagementAuthorities = useWithAuthorities([permissions.dataManagement]);
  const [isDialogOpen, setDialogOpen] = useState(false);
  
  const handleCloseDialog = () => {
    setDialogOpen(false);
  };
  
  const handleLeaveOrganization = (e: any) => {
    e.preventDefault();
    setDialogOpen(true);
  };
  
  const handleLeaveAccept = async (e: any) => {
    e.preventDefault();
    
    try {
      await withDataManagementAuthorities(async () => {
        await postLeaveOrganizationAPI(currentOrganization.organizationUeid);
        navigate(routes.agent);
        reloadOrganizations();
        toast.success('Пользователь удален из организации');
      });
    } catch (error) {
      toast.error('Произошла ошибка при удалении пользователя из организации');
    }
    finally {
      setDialogOpen(false);
    }
  };
  
  if (!currentOrganization) {
    return null;
  }
  
  return (
    <>
      <a href="#" onClick={handleLeaveOrganization} className={className}>
        Выйти из организации
      </a>
      <Modal
        isOpen={isDialogOpen}
        onClose={handleCloseDialog}
        title="Выход из организации"
        content={
          <Text type="p" muted>
            Вы действительно хотите выйти из организации "{currentOrganization.name}"?
          </Text>
        }
        footer={
          <>
            <Button onClick={handleCloseDialog} className={styles['modal-button']}>
              Отмена
            </Button>
            <Button variant="outlined" onClick={handleLeaveAccept} className={styles['modal-button']}>
              Выйти
            </Button>
          </>
        }
      />
    </>
  );
};

export default LeaveOrganizationLink;
